export const ERC20CappedMintablePausablePermit = {
  _format: "hh-sol-artifact-1",
  contractName: "ERC20CappedMintablePausablePermit",
  sourceName: "contracts/templates/ERC20CappedMintablePausablePermit.sol",
  abi: [
    {
      inputs: [
        {
          internalType: "string",
          name: "name",
          type: "string",
        },
        {
          internalType: "string",
          name: "symbol",
          type: "string",
        },
        {
          internalType: "address",
          name: "initialOwner",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "cap",
          type: "uint256",
        },
      ],
      stateMutability: "payable",
      type: "constructor",
    },
    {
      inputs: [],
      name: "ECDSAInvalidSignature",
      type: "error",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "length",
          type: "uint256",
        },
      ],
      name: "ECDSAInvalidSignatureLength",
      type: "error",
    },
    {
      inputs: [
        {
          internalType: "bytes32",
          name: "s",
          type: "bytes32",
        },
      ],
      name: "ECDSAInvalidSignatureS",
      type: "error",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "increasedSupply",
          type: "uint256",
        },
        {
          internalType: "uint256",
          name: "cap",
          type: "uint256",
        },
      ],
      name: "ERC20ExceededCap",
      type: "error",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "spender",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "allowance",
          type: "uint256",
        },
        {
          internalType: "uint256",
          name: "needed",
          type: "uint256",
        },
      ],
      name: "ERC20InsufficientAllowance",
      type: "error",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "sender",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "balance",
          type: "uint256",
        },
        {
          internalType: "uint256",
          name: "needed",
          type: "uint256",
        },
      ],
      name: "ERC20InsufficientBalance",
      type: "error",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "approver",
          type: "address",
        },
      ],
      name: "ERC20InvalidApprover",
      type: "error",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "cap",
          type: "uint256",
        },
      ],
      name: "ERC20InvalidCap",
      type: "error",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "receiver",
          type: "address",
        },
      ],
      name: "ERC20InvalidReceiver",
      type: "error",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "sender",
          type: "address",
        },
      ],
      name: "ERC20InvalidSender",
      type: "error",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "spender",
          type: "address",
        },
      ],
      name: "ERC20InvalidSpender",
      type: "error",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "deadline",
          type: "uint256",
        },
      ],
      name: "ERC2612ExpiredSignature",
      type: "error",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "signer",
          type: "address",
        },
        {
          internalType: "address",
          name: "owner",
          type: "address",
        },
      ],
      name: "ERC2612InvalidSigner",
      type: "error",
    },
    {
      inputs: [],
      name: "EnforcedPause",
      type: "error",
    },
    {
      inputs: [],
      name: "ExpectedPause",
      type: "error",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "account",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "currentNonce",
          type: "uint256",
        },
      ],
      name: "InvalidAccountNonce",
      type: "error",
    },
    {
      inputs: [],
      name: "InvalidShortString",
      type: "error",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "owner",
          type: "address",
        },
      ],
      name: "OwnableInvalidOwner",
      type: "error",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "account",
          type: "address",
        },
      ],
      name: "OwnableUnauthorizedAccount",
      type: "error",
    },
    {
      inputs: [
        {
          internalType: "string",
          name: "str",
          type: "string",
        },
      ],
      name: "StringTooLong",
      type: "error",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "owner",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "spender",
          type: "address",
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "value",
          type: "uint256",
        },
      ],
      name: "Approval",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [],
      name: "EIP712DomainChanged",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "previousOwner",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "newOwner",
          type: "address",
        },
      ],
      name: "OwnershipTransferred",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: false,
          internalType: "address",
          name: "account",
          type: "address",
        },
      ],
      name: "Paused",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "from",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "to",
          type: "address",
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "value",
          type: "uint256",
        },
      ],
      name: "Transfer",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: false,
          internalType: "address",
          name: "account",
          type: "address",
        },
      ],
      name: "Unpaused",
      type: "event",
    },
    {
      inputs: [],
      name: "DOMAIN_SEPARATOR",
      outputs: [
        {
          internalType: "bytes32",
          name: "",
          type: "bytes32",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "owner",
          type: "address",
        },
        {
          internalType: "address",
          name: "spender",
          type: "address",
        },
      ],
      name: "allowance",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "spender",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "value",
          type: "uint256",
        },
      ],
      name: "approve",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool",
        },
      ],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "account",
          type: "address",
        },
      ],
      name: "balanceOf",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "cap",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "decimals",
      outputs: [
        {
          internalType: "uint8",
          name: "",
          type: "uint8",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "eip712Domain",
      outputs: [
        {
          internalType: "bytes1",
          name: "fields",
          type: "bytes1",
        },
        {
          internalType: "string",
          name: "name",
          type: "string",
        },
        {
          internalType: "string",
          name: "version",
          type: "string",
        },
        {
          internalType: "uint256",
          name: "chainId",
          type: "uint256",
        },
        {
          internalType: "address",
          name: "verifyingContract",
          type: "address",
        },
        {
          internalType: "bytes32",
          name: "salt",
          type: "bytes32",
        },
        {
          internalType: "uint256[]",
          name: "extensions",
          type: "uint256[]",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "to",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "amount",
          type: "uint256",
        },
      ],
      name: "mint",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "moontools",
      outputs: [
        {
          internalType: "address",
          name: "",
          type: "address",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "name",
      outputs: [
        {
          internalType: "string",
          name: "",
          type: "string",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "owner",
          type: "address",
        },
      ],
      name: "nonces",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "owner",
      outputs: [
        {
          internalType: "address",
          name: "",
          type: "address",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "pause",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "paused",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "owner",
          type: "address",
        },
        {
          internalType: "address",
          name: "spender",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "value",
          type: "uint256",
        },
        {
          internalType: "uint256",
          name: "deadline",
          type: "uint256",
        },
        {
          internalType: "uint8",
          name: "v",
          type: "uint8",
        },
        {
          internalType: "bytes32",
          name: "r",
          type: "bytes32",
        },
        {
          internalType: "bytes32",
          name: "s",
          type: "bytes32",
        },
      ],
      name: "permit",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "price",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "renounceOwnership",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "symbol",
      outputs: [
        {
          internalType: "string",
          name: "",
          type: "string",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "totalSupply",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "to",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "value",
          type: "uint256",
        },
      ],
      name: "transfer",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool",
        },
      ],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "from",
          type: "address",
        },
        {
          internalType: "address",
          name: "to",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "value",
          type: "uint256",
        },
      ],
      name: "transferFrom",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool",
        },
      ],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "newOwner",
          type: "address",
        },
      ],
      name: "transferOwnership",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "unpause",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
  ],
  bytecode:
    "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",
  deployedBytecode:
    "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",
  linkReferences: {},
  deployedLinkReferences: {},
};
